
import "./Assets/css/apps.css"
import "./Assets/css/apps_inner.css"
import "./Assets/css/bootstrap.css"
import "./Assets/css/font-awesome.css"
import "./Assets/css/res.css"

import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';

import router from './routes/router';



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<RouterProvider router={router} />);

reportWebVitals();
